import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Login from './views/Login.vue'
import Register from './views/Register.vue'
import Subscribe from './views/Subscribe.vue'
import Account from './views/Account.vue'
import Prognostics from './views/Prognostics.vue'
import Prognostic from './views/Prognostic.vue'
import Dashboard from './views/Dashboard.vue'
import Users from './views/Users.vue'
import { auth } from './firebase.js'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/connexion',
      name: 'connexion',
      component: Login
    },
    {
      path: '/creation-compte',
      name: 'creation-compte',
      component: Register
    },
    {
      path: '/abonnement/:paypal?',
      name: 'subscribe',
      component: Subscribe
    },
    {
      path: '/erreur',
      name: 'error',
      component: Home
    },
    {
      path: '/mon-compte',
      name: 'account',
      component: Account,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/pronostics/:month?',
      name: 'prognostics',
      component: Prognostics,
      meta: {
        requiresAuth: true,
        requiresSubscribed: true
      }
    },
    {
      path: '/pronostic/:id',
      name: 'prognostic',
      component: Prognostic
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    },
    {
      path: '/users',
      name: 'users',
      component: Users,
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin)
  const requiresSubscribed = to.matched.some(record => record.meta.requiresSubscribed)

  if(requiresAuth && !auth.user)
    next({ path: '/connexion', query: { redirect: to.path } })
  else if(requiresAdmin && (!auth.user || !auth.user.admin))
    next('/erreur')
  else if(requiresSubscribed && (!auth.user || !auth.user.subscribed))
    next('/abonnement')
  else
    next()
})
export default router;